import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import moment from "moment";
import Swal from "sweetalert2";
import { DatatableFunc } from "../../../Common/DatatableFunc";
import ReactDataTable from "../../../Common/ReactDataTable";

const TransactionList = () => {
  const [transactionData, setTransactionData] = useState([]);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const location = useLocation();

  useEffect(() => {
    fetchData();
    
    if (location.state?.message) {
      showAlert(location.state.type, location.state.message);
    }
  }, [location.state]);

  const fetchData = async () => {
    try {
      const [transactionsResponse, roleResponse] = await Promise.all([
        Http.get("/accounts/transactions"),
        Http.get("/user-role"),
      ]);
      
      setTransactionData(transactionsResponse.data);
      setRole(roleResponse.data);
      setLoading(false);
    } catch (error) {
      console.error("Fetch error:", error);
      setLoading(false);
    }
  };
  
  const showAlert = (type, message) => {
    Swal.fire({
      icon: type === "success" ? "success" : "error",
      title: type === "success" ? "Success" : "Error",
      text: message,
      timer: 3000,
      showConfirmButton: false
    });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const cols = [
    {
      field: "date",
      header: "Date",
      body: (rowData) => moment(rowData.date).format("DD/MM/YYYY"),
      sortable: true,
    },
    {
      field: "reference",
      header: "Reference",
      sortable: true,
    },
    {
      field: "account.name",
      header: "Account",
      sortable: true,
    },
    {
      field: "type",
      header: "Type",
      body: (rowData) => (
        <span className={`badge ${rowData.type === 'income' ? 'bg-success' : 'bg-danger'}`}>
          {rowData.type === 'income' ? 'Income' : 'Expense'}
        </span>
      ),
      sortable: true,
    },
    {
      field: "amount",
      header: "Amount",
      body: (rowData) => rowData.amount ? rowData.amount.toFixed(2) : "0.00",
      sortable: true,
    },
    {
      field: "description",
      header: "Description",
      sortable: true,
    },
    {
      field: "action",
      header: "Actions",
      body: actionTemplate,
    },
  ];

  function actionTemplate(rowData) {
    return (
      <div className="d-flex gap-2">
        <Link
          to={`/accounts-for-supplychain/transaction/view/${rowData.id}`}
          className="btn btn-info btn-sm"
        >
          <i className="fa fa-eye"></i>
        </Link>
        {(role === "admin" || role === "accounts") && (
          <>
            <Link
              to={`/accounts-for-supplychain/transaction/edit/${rowData.id}`}
              className="btn btn-primary btn-sm"
            >
              <i className="fa fa-edit"></i>
            </Link>
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-sm"
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this transaction?")) {
                  Http.delete(`/accounts/transactions/${rowData.id}`)
                    .then((res) => {
                      showAlert("success", res.data.message);
                      fetchData();
                    })
                    .catch((error) => {
                      console.error("Delete error:", error);
                      showAlert("error", "Failed to delete transaction");
                    });
                }
              }}
            />
          </>
        )}
      </div>
    );
  }

  const renderHeader = () => {
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div>
          {(role === "admin" || role === "accounts") && (
            <Link
              to="/accounts-for-supplychain/transaction/create"
              className="btn btn-primary"
            >
              <i className="fa fa-plus"></i> Add New Transaction
            </Link>
          )}
        </div>
        <div className="table-header d-flex align-items-center">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Search..."
            />
          </span>
        </div>
      </div>
    );
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">All Transactions</h5>
        </div>

        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <ReactDataTable
              data={transactionData}
              columns={cols}
              filters={filters}
              globalFilterFields={["reference", "description", "account.name"]}
              globalFilterValue={globalFilterValue}
              header={renderHeader}
              loading={loading}
              emptyMessage="No transactions found."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionList;